const ShowCards = () => import("@/components/BankCard/ShowCards/index");
const AddCard = () => import("@/components/BankCard/AddCard/index");
// import { OperationService } from "@/services";
export default {
  name: "deposit-confirmation-card",
  components: { ShowCards, AddCard },
  props: ["amountData", "pspId"],
  data() {
    return {
      color: "gray8",
      addCardDialog: false,
      waitRequest: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // handleIpg() {
    //   this.waitRequest = true;
    //   let dataObject = {
    //     amount: this.amountData,
    //     psp_id: this.pspId,
    //   };
    //   OperationService.depositIRR(dataObject)
    //     .then((response) => {
    //       window.location.replace(response.data.data.url);
    //     })
    //     .catch(() => {
    //       this.waitRequest = false;
    //       this.$emit("waiteRequest", this.waitRequest);
    //     });
    //   this.$emit("confirmOrder", false);
    //   this.$emit("waiteRequest", this.waitRequest);
    // },
    handleDialog() {
      this.$emit("confirmOrder", false);
      this.addCardDialog = true;
    }
  }
};
